import React from "react";
import history from "../../util/history";
import { ErrorContainer, RetryButton } from "./styles";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo);
  }

  componentDidMount() {
    this.unlisten = history.listen(() => {
      if (this.state.hasError) {
        this.setState({ hasError: false });
      }
    });
  }

  componentWillUnmount() {
    if (this.unlisten) this.unlisten();
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <ErrorContainer>
        <h5>Ocorreu um erro inesperado nesta tela.</h5>
        <p>Tente novamente ou navegue para outra tela pelo menu.</p>
        <RetryButton
          className="purpleButton"
          onClick={() => this.setState({ hasError: false })}
        >
          Tentar novamente
        </RetryButton>
      </ErrorContainer>
    );
  }
}

export default ErrorBoundary;
